import {apiClient} from "@/state/modules/apiClient";
const controller = "CaiDatCongDan";

export const state = {
    reloadAuthUser: false,
}
export const mutations = {
}
export const actions = {
    async get({commit}) {
        return apiClient.get(controller +"/get");
    },
    async create({commit}, values) {
        return apiClient.post(controller +"/create", values);
    },
    async delete({commit}, id) {
        return await apiClient.delete(controller +"/delete/" + id);
    },
    async getFile({commit}, id) {
        return await apiClient.get("CaiDatCongDan" +"/get-huongdansudung");
    },
};
